/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelPraticaEventoDTO } from '../model/models';
import { PraticaEventoListFilter } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListPraticaEventiRequestParams {
    idTipoPratica: string;
    idPratica: string;
    filter: PraticaEventoListFilter;
    pageable: Pageable;
}


export interface GestioneEventiPraticaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Timeline paginata degli eventi della pratica. Filtri opzionali: event_type (multi raw, comma-separated), actor_type (multi raw), from/to (ISO-8601). Sort default event_timestamp DESC, customizzabile via ?sort&#x3D;.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/eventi
* @param requestParameters
     */
    listPraticaEventi(requestParameters: ListPraticaEventiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaEventoDTO>;

}
